import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';

import { CadastrarPublicoAlvoComponent } from './cadastrar-publico-alvo/cadastrar-publico-alvo.component';
import { PublicoAlvoRoutingModule } from './publico-alvo-routing.module';
import { PublicoAlvoComponent } from './publico-alvo.component';


@NgModule({
  declarations: [
    PublicoAlvoComponent,
    CadastrarPublicoAlvoComponent
  ],
  imports: [
    CommonModule,
    MaterialCommonModule,
    PublicoAlvoRoutingModule
  ]
})
export class PublicoAlvoModule { }
